
import LolePicture from '~/components/picture/lole-picture'
import LoleVideoPicture from '~/components/picture/lole-video-picture'
export default {
  components: { LolePicture, LoleVideoPicture },
  props: {
    medias: {
      type: Array,
      default: () => [],
    },
    product: {
      type: Object,
      default: () => ({}),
    },
  },
}
